import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const RealTimeSystemsClassificationModule = () => (
  <QPhototModuleSubtopic
    title="Classification of Real Time Systems, Issues & Challenges in RTS"
    videos={[
      "https://www.youtube.com/embed/d5duBWX71M4",
      "https://www.youtube.com/embed/ECnLyfrrjGQ"
    ]}
    takeaways={[]}
    questions={[
      {
        text:
          "State the design challenges and characteristics of an embedded system. Draw the schematic diagram and write an embedded program using 8051 for the following: A door sensor is connected to P1.1 and a buzzer is connected to P1.7. Monitor the door sensor and when it opens, sound the buzzer."
      },
      {
        text:
          "Identify and evaluate the constraints and challenges in designing any special purpose embedded system and choose the appropriate identified parameters for the following system with enough justifications: GPS (Global Positioning System)."
      },
      {
        text:
          "Design and analyze a Real-Time Weather Forecast Station that continuously monitors weather conditions and provides up-to-date forecasts to users such as meteorologists, pilots, and emergency response teams. The system may include sensors for temperature, humidity, barometric pressure, wind speed, and precipitation. Using the given criteria (Types of Events, Functional Correctness, Timeliness), evaluate the system design to ensure it meets the requirements for real-time weather monitoring and forecasting."
      },
      {
        text:
          "Analyze the challenges and issues with respect to embedded system design for the following scenarios:\n(i) Logistics\n(ii) Home Automation"
      },
      {
        text:
          "Identify and evaluate the constraints and challenges in designing any special purpose embedded system and choose the appropriate identified parameters for the following system with enough justifications: ATM (Automated Teller Machine) system."
      },
      {
        text:
          "How do the design requirements and constraints differ between hard and soft real-time systems? Provide one example for each type of system."
      },
      {
        text:
          "Differentiate hardware and software development tools with an example for each in the context of embedded and real-time system design."
      },
      {
        text:
          "\"All embedded systems are not real time systems.\" Justify this statement and give one example of an embedded system that is real time and one that is not."
      },
      {
        text:
          "Identify if the following systems are Soft RTS or Hard RTS with justification:\n• A cruise control system\n• An ATM machine\n• A pacemaker\n• A Fitbit watch\n• A smart fridge"
      }
    ]}
    exampleVideos={[]}
  />
);

export default RealTimeSystemsClassificationModule;
